<template>
    <CContainer>
        <CRow v-if="$policy('wallet').view_any_or_group">
            <CCol col="12" class="d-flex overflow-auto px-0">
                <InvFilterIt />
                <InvSortIt class="mr-auto" />
            </CCol>
        </CRow>

        <InvTable class="mt-2" />
    </CContainer>
</template>

<script>
import { InvTable, InvFilterIt, InvSortIt } from './partials'

export default {
    name: 'Invoices',

    components: {
        InvSortIt,
        InvTable,
        InvFilterIt
    },
}
</script>